import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Rerouter = (props) => {
  const navigate = useNavigate(),
    { state } = useLocation();

  useEffect(() => {
    navigate(state);
  }, []);

  return null;
};

export default Rerouter;
